var React = require('react');

function IconClip (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M428.1 416.6L260.5 582.7c-28.6 28.3-44 65.1-44 104.9 0 39.8 15.4 76.6 44 104.9 58.7 58.2 153.7 58.2 211.6 0l378.4-375.1c39.4-39 61-91.1 61-146.2S890 164 850.6 124.9c-81.9-81.2-213.9-81.2-295.8 0L177.1 499.3c-51 50.5-78.8 117.1-78.8 188.3s27.8 138.6 78.8 188.3c51 50.5 118.2 78.1 190 78.1s139.8-27.6 190-78.1l167.6-166.1-44.8-44.4-167.6 166.2c-38.6 38.3-90.4 59.7-145.2 59.7s-106.6-21.4-145.2-59.7-60.2-89.6-60.2-143.9c0-54.4 21.6-105.6 60.2-143.9l377.7-374.4c27.8-27.6 64.1-42.1 102.7-42.1s75.7 15.2 102.7 42c27.8 27.6 42.5 63.5 42.5 101.8s-15.4 75-42.5 101.8L426.6 748.1c-33.2 32.9-88 32.9-122 0-16.3-16.1-25.6-37.5-25.6-60.5s9.3-44.4 25.5-60.5L472.9 461l-44.8-44.4z"}));
}

IconClip.displayName = "IconClip";

IconClip.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconClip;

IconClip.default = IconClip;
